import { createSlice } from "@reduxjs/toolkit";
import { userRegistrationSliceState } from "../types";

const initialState: userRegistrationSliceState = {
  gstNumber: 'GST21212122',
};

const userRegistrationStateSlice = createSlice({
  name: "userRegistrationSlice",
  initialState,
  reducers: {
    setGstNumber(state, action) {
      state.gstNumber = action.payload;
    },
  },
});

export const { setGstNumber } = userRegistrationStateSlice.actions;
export default userRegistrationStateSlice.reducer;
